import { onDocumentLoaded } from '@theme/utilities';

const capitalizeElements = (selector) => {
  try {
    const elements = document.querySelectorAll(selector);

    if (elements.length === 0) {
      console.warn(`No se encontraron elementos con el selector: ${selector}`);
      return;
    }

    elements.forEach(element => {
      const text = element.textContent;
      const capitalizedText = text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      
      element.textContent = capitalizedText;
    });
  } catch (error) {
    console.error(`Error al capitalizar los elementos con el selector "${selector}":`, error);
  }
};

onDocumentLoaded(() => {
  capitalizeElements('.product-details h1');
  capitalizeElements('.card-gallery .contents p');
  capitalizeElements('.product-card a.contents p');
});